import React from 'react';
import T from 'i18n-react';

const EUWorkFlowSvg = (props) => {
  return (
    <svg
      width={450}
      height={39}
      viewBox="0 0 788 68"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M168 20.98a.749.749 0 01.75-.75h14.14l-4.08-3.94a.751.751 0 010-1.06.714.714 0 01.54-.23.731.731 0 01.52.21l5.4 5.23a.753.753 0 01.23.54.758.758 0 01-.23.54l-5.42 5.22a.74.74 0 01-.562.307.75.75 0 01-.438-1.387l4.04-3.93h-14.14a.759.759 0 01-.75-.75zM382 20.98a.749.749 0 01.75-.75h14.14l-4.08-3.94a.751.751 0 010-1.06.714.714 0 01.54-.23.731.731 0 01.52.21l5.4 5.23a.753.753 0 01.23.54.758.758 0 01-.23.54l-5.42 5.22a.74.74 0 01-.562.307.75.75 0 01-.438-1.387l4.04-3.93h-14.14a.759.759 0 01-.75-.75zM185.5 43.068a.75.75 0 01-.75.75h-14.14l4.08 3.94a.752.752 0 010 1.06.72.72 0 01-.54.23.73.73 0 01-.52-.21l-5.4-5.23a.753.753 0 01-.23-.54.758.758 0 01.23-.54l5.42-5.22a.741.741 0 01.562-.307.75.75 0 01.438 1.387l-4.04 3.93h14.14a.759.759 0 01.75.75zM399.5 43.068a.75.75 0 01-.75.75h-14.14l4.08 3.94a.752.752 0 010 1.06.72.72 0 01-.54.23.73.73 0 01-.52-.21l-5.4-5.23a.753.753 0 01-.23-.54.758.758 0 01.23-.54l5.42-5.22a.741.741 0 01.562-.307.75.75 0 01.438 1.387l-4.04 3.93h14.14a.759.759 0 01.75.75z"
        fill="gray"
      />
      <g filter="url(#prefix__filter0_d)">
        <mask id="prefix__a" fill="#fff">
          <path d="M567 55V5a5 5 0 00-5-5H432a5 5 0 00-5 5v50a5 5 0 005 5h130a5 5 0 005-5z" />
        </mask>
        <path
          d="M567 55V5a5 5 0 00-5-5H432a5 5 0 00-5 5v50a5 5 0 005 5h130a5 5 0 005-5z"
          fill="#fff"
        />
        <path
          d="M566 5v50h2V5h-2zM428 55V5h-2v50h2zm64.882 4H432v2h60.882v-2zm0 2h3.983v-2h-3.983v2zM562 59h-61.153v2H562v-2zm-65.135 2h3.982v-2h-3.982v2zM432 1h65v-2h-65v2zm65 0h65v-2h-65v2zm-71 54a6 6 0 006 6v-2a4 4 0 01-4-4h-2zm140 0a4 4 0 01-4 4v2a6 6 0 006-6h-2zm2-50a6 6 0 00-6-6v2a4 4 0 014 4h2zM428 5a4 4 0 014-4v-2a6 6 0 00-6 6h2z"
          fill="#0696D7"
          mask="url(#prefix__a)"
        />
      </g>
      <text
        fill="#3C3C3C"
        style={{
          whiteSpace: 'pre',
        }}
        fontFamily="Artifakt Element"
        fontSize={14}
        fontWeight={600}
        letterSpacing={0}
      >
        <tspan x={465} y={35.809}>
          {T.translate('adminWorkflow.rols.cm')}
        </tspan>
      </text>
      <g filter="url(#prefix__filter1_d)">
        <mask id="prefix__b" fill="#fff">
          <path d="M355 55V5a5 5 0 00-5-5H220a5 5 0 00-5 5v50a5 5 0 005 5h130a5 5 0 005-5z" />
        </mask>
        <path
          d="M355 55V5a5 5 0 00-5-5H220a5 5 0 00-5 5v50a5 5 0 005 5h130a5 5 0 005-5z"
          fill="#fff"
        />
        <path
          d="M354 5v50h2V5h-2zM216 55V5h-2v50h2zm64.882 4H220v2h60.882v-2zm0 2h3.983v-2h-3.983v2zM350 59h-61.153v2H350v-2zm-65.135 2h3.982v-2h-3.982v2zM220 1h65v-2h-65v2zm65 0h65v-2h-65v2zm-71 54a6 6 0 006 6v-2a4 4 0 01-4-4h-2zm140 0a4 4 0 01-4 4v2a6 6 0 006-6h-2zm2-50a6 6 0 00-6-6v2a4 4 0 014 4h2zM216 5a4 4 0 014-4v-2a6 6 0 00-6 6h2z"
          fill="#0696D7"
          mask="url(#prefix__b)"
        />
      </g>
      <text
        fill="#3C3C3C"
        style={{
          whiteSpace: 'pre',
        }}
        fontFamily="Artifakt Element"
        fontSize={14}
        fontWeight={600}
        letterSpacing={0}
      >
        <tspan x={253} y={35.809}>
          {T.translate('adminWorkflow.rols.gc')}
        </tspan>
      </text>
      <g filter="url(#prefix__filter2_d)">
        <mask id="prefix__c" fill="#fff">
          <path d="M140 55V5a5 5 0 00-5-5H5a5 5 0 00-5 5v50a5 5 0 005 5h130a5 5 0 005-5z" />
        </mask>
        <path
          d="M140 55V5a5 5 0 00-5-5H5a5 5 0 00-5 5v50a5 5 0 005 5h130a5 5 0 005-5z"
          fill="#fff"
        />
        <path
          d="M139 5v50h2V5h-2zM1 55V5h-2v50h2zm64.882 4H5v2h60.882v-2zm0 2h3.983v-2h-3.983v2zM135 59H73.847v2H135v-2zm-65.135 2h3.982v-2h-3.982v2zM5 1h65v-2H5v2zm65 0h65v-2H70v2zM-1 55a6 6 0 006 6v-2a4 4 0 01-4-4h-2zm140 0a4 4 0 01-4 4v2a6 6 0 006-6h-2zm2-50a6 6 0 00-6-6v2a4 4 0 014 4h2zM1 5a4 4 0 014-4v-2a6 6 0 00-6 6h2z"
          fill="#0696D7"
          mask="url(#prefix__c)"
        />
      </g>
      <text
        fill="#3C3C3C"
        style={{
          whiteSpace: 'pre',
        }}
        fontFamily="Artifakt Element"
        fontSize={14}
        fontWeight={600}
        letterSpacing={0}
      >
        <tspan x={42} y={35.9}>
          {T.translate('adminWorkflow.rols.sc')}
        </tspan>
      </text>
      <path
        d="M595 20.98a.749.749 0 01.75-.75h14.14l-4.08-3.94a.751.751 0 010-1.06.714.714 0 01.54-.23.731.731 0 01.52.21l5.4 5.23a.753.753 0 01.23.54.758.758 0 01-.23.54l-5.42 5.22a.74.74 0 01-.562.307.75.75 0 01-.438-1.387l4.04-3.93h-14.14a.759.759 0 01-.75-.75zM612.5 43.068a.75.75 0 01-.75.75h-14.14l4.08 3.94a.752.752 0 010 1.06.72.72 0 01-.54.23.73.73 0 01-.52-.21l-5.4-5.23a.753.753 0 01-.23-.54.758.758 0 01.23-.54l5.42-5.22a.741.741 0 01.562-.307.75.75 0 01.438 1.387l-4.04 3.93h14.14a.759.759 0 01.75.75z"
        fill="gray"
      />
      <g filter="url(#prefix__filter3_d)">
        <mask id="prefix__d" fill="#fff">
          <path d="M780 55V5a5 5 0 00-5-5H645a5 5 0 00-5 5v50a5 5 0 005 5h130a5 5 0 005-5z" />
        </mask>
        <path
          d="M780 55V5a5 5 0 00-5-5H645a5 5 0 00-5 5v50a5 5 0 005 5h130a5 5 0 005-5z"
          fill="#fff"
        />
        <path
          d="M779 5v50h2V5h-2zM641 55V5h-2v50h2zm64.882 4H645v2h60.882v-2zm0 2h3.983v-2h-3.983v2zM775 59h-61.153v2H775v-2zm-65.135 2h3.982v-2h-3.982v2zM645 1h65v-2h-65v2zm65 0h65v-2h-65v2zm-71 54a6 6 0 006 6v-2a4 4 0 01-4-4h-2zm140 0a4 4 0 01-4 4v2a6 6 0 006-6h-2zm2-50a6 6 0 00-6-6v2a4 4 0 014 4h2zM641 5a4 4 0 014-4v-2a6 6 0 00-6 6h2z"
          fill="#0696D7"
          mask="url(#prefix__d)"
        />
      </g>
      <text
        fill="#3C3C3C"
        style={{
          whiteSpace: 'pre',
        }}
        fontFamily="Artifakt Element"
        fontSize={14}
        fontWeight={600}
        letterSpacing={0}
      >
        <tspan x={671} y={35.9}>
          {T.translate('adminWorkflow.rols.arch.EU')}
        </tspan>
      </text>
      <defs>
        <filter
          id="prefix__filter0_d"
          x={427}
          y={0}
          width={148}
          height={68}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
          <feOffset dx={4} dy={4} />
          <feGaussianBlur stdDeviation={2} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0.521569 0 0 0 0 0.870588 0 0 0 0.1 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
        </filter>
        <filter
          id="prefix__filter1_d"
          x={215}
          y={0}
          width={148}
          height={68}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
          <feOffset dx={4} dy={4} />
          <feGaussianBlur stdDeviation={2} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0.521569 0 0 0 0 0.870588 0 0 0 0.1 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
        </filter>
        <filter
          id="prefix__filter2_d"
          x={0}
          y={0}
          width={148}
          height={68}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
          <feOffset dx={4} dy={4} />
          <feGaussianBlur stdDeviation={2} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0.521569 0 0 0 0 0.870588 0 0 0 0.1 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
        </filter>
        <filter
          id="prefix__filter3_d"
          x={640}
          y={0}
          width={148}
          height={68}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
          <feOffset dx={4} dy={4} />
          <feGaussianBlur stdDeviation={2} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0.521569 0 0 0 0 0.870588 0 0 0 0.1 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
        </filter>
      </defs>
    </svg>
  );
};

export default EUWorkFlowSvg;
